import { takeLatest } from 'redux-saga/effects';

import { getPermissions } from '../actions';

import { handleGetPermissionsRequest } from './getPermissionsSaga';

export default function* rolesSaga() {
  yield takeLatest(getPermissions.TRIGGER, handleGetPermissionsRequest);
}
